module.exports = __webpack_public_path__ + "static/media/exit.6f9d2a24.svg";